import { useEffect, useState } from "react";
import "./ModalWindow.scss";

const ModalWindow = ({ isOpenModal, setOpenModal, element }) => {
    return (
        <div className={`modal ${isOpenModal ? "modal-active" : "modal-closing"}`}>
            <div className="modal__window">
                <div className="close__modal">
                    <button className="close__modal-btn" onClick={() => setOpenModal(false)}>
                        ×
                    </button>
                </div>
                <h3>Contact me</h3>
                {element}
            </div>
        </div>
    );
};

export default ModalWindow;
